import { useMutation } from "@tanstack/react-query";

import * as authApi from "../api";
import { useUserActions } from "../store";
import type { LoginByWechatData } from "../types";

export function useWechatLoginMutation() {
  const { setToken } = useUserActions();

  return useMutation({
    mutationFn: (payload: LoginByWechatData) => authApi.loginByWechat(payload),
    onSuccess: (response) => {
      setToken(response.token);
    },
  });
}
